import { createRef, useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { set_onboarding_step } from '../../action/onboarding'
import ModalTutorial from './Modals/ModalTutorial'
import { trans } from '../../utils/utilsTrans'

function Tabs({ tabs, currentTab, changeTab, customClass, hasTutorial, onboarding, set_onboarding_step }) {
  const ref = useRef(tabs.map(() => createRef()))
  const [linePosition, setLinePosition] = useState(0)
  const [lineWidth, setLineWidth] = useState(0)

  const activeIndex = tabs.findIndex((tab) => tab.slug === currentTab)
  const onBoardingIndex = activeIndex + 1

  useEffect(() => {
    if (onBoardingIndex > onboarding.index) {
      set_onboarding_step(onBoardingIndex)
    }

    const activeRef = ref.current[activeIndex]?.current
    setLinePosition(activeRef?.offsetLeft || 0)
    setLineWidth(activeRef?.clientWidth || 0)
  }, [tabs])

  return (
    <ul
      className={`pb-6 sm:pb-0 flex sm:flex-row flex-col items-center flex-wrap mx-auto -mb-px relative ${customClass}`}
    >
      {tabs.map((tab, index) => (
        <li className='mr-2 relative' key={tab.slug} ref={ref.current[index]}>
          <button
            type='button'
            data-cy={`tab-${tab.slug}`}
            className={`inline-block rounded-t-lg border-b-2 px-6 py-4 sm:px-16 sm:py-12 text-xs sm:text-sm border-transparent hover:text-primary mb-[-1px] transition-color duration-200 ${
              tab.slug === currentTab ? 'text-primary' : ''
            }`}
            onClick={() => changeTab(tab.slug)}
          >
            {tab.icon ? <i className={`mr-10 ${tab.icon}`} /> : null}
            <span>{tab.label}</span>
          </button>
          {hasTutorial && onboarding?.isActive && (onboarding?.index <= onBoardingIndex) && tab.slug === currentTab ? (
            <ModalTutorial
              index={onBoardingIndex}
              total={5}
              position='left'
              onNext={() => {
                if (tabs[onBoardingIndex]) {
                  changeTab(tabs[onBoardingIndex]?.slug)
                } else {
                  set_onboarding_step(4)
                }
              }}
              title={trans('slideshows.add_content')}
              text={trans('slideshows.explore_and_add')}
            />
          ) : null}
        </li>
      ))}
      <div
        className='hidden sm:block bg-primary h-[2px] sm:absolute left-0 bottom-[-1px] transition-all duration-200'
        style={{
          transform: `translate(${linePosition}px)`,
          width: `${lineWidth}px`,
        }}
      />
    </ul>
  )
}

const mapStateToProps = (state) => {
  return {
    onboarding: state.onboarding,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    ...bindActionCreators({ set_onboarding_step }, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Tabs)
